<div class="row align-items-center">
    <div class="col">
      <label> {{ label }} </label>
    </div>
    <div class="col-auto">
      <p-toggleswitch
        [(ngModel)]="checked"
        [disabled]="disabled"
        (ngModelChange)="toggleSwitch()" />
    </div>
  </div>